/* eslint-disable */
import {
  Autocomplete,
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  TextField,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import { getCacheData } from "../../services/CacheService";
import { getBlCrSubMarcas } from "../../services/BlCrSubMarcaService";
import { saveCristalProducto } from "../../services/CristalProductoService";
import WaitingDialog from "../../utils/WaitingDialog";

const initialState = {
  id: null,
  descripcion: "",
  descripcionCorta: "",
  idBlCrTipo: null,
  idBlCrMaterial: null,
  idCrOrigen: null,
  idBlCrMarca: null,
  idBlCrSubmarca: null,
  idBlCrColor: null,
  disponibleOs: false,
  observaciones: "",
};

const nameItemText = "Producto de Cristal";
const itemGender = "M";
//
// ########################################################################### 
//
const CristalProductoDialog = ({
  onSave,
  onClose,
  itemCrud,
  actionCrud,
  setMessage,
  setShowMessage,
}) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [blCrMarcas, setBlCrMarcas] = useState([]);
  const [blCrSubMarcas, setBlCrSubMarcas] = useState([]);
  const [blCrMateriales, setBlCrMateriales] = useState([]);
  const [blCrTipos, setBlCrTipos] = useState([]);
  const [blCrColores, setBlCrColores] = useState([]);
  const [crOrigenes, setCrOrigenes] = useState([]);
  const [valueACBlCrMarca, setValueACBlCrMarca] = useState
    (
      itemCrud.blCrMarca
    )
  const [inputValueACBlCrMarca, setInputValueACBlCrMarca] = useState("");
  const [valueACBlCrSubMarca, setValueACBlCrSubMarca] = useState
    (
      itemCrud.blCrSubMarca
    )
  const [inputValueACBlCrSubMarca, setInputValueACBlCrSubMarca] = useState("");
  const [valueACBlCrMaterial, setValueACBlCrMaterial] = useState
    (
      itemCrud.blCrMaterial
    )
  const [inputValueACBlCrMaterial, setInputValueACBlCrMaterial] = useState("");
  const [valueACBlCrTipo, setValueACBlCrTipo] = useState
    (
      itemCrud.blCrTipo
    )
  const [inputValueACBlCrTipo, setInputValueACBlCrTipo] = useState("");
  const [valueACBlCrColor, setValueACBlCrColor] = useState
    (
      itemCrud.blCrColor
    )
  const [inputValueACBlCrColor, setInputValueACBlCrColor] = useState("");
  const [valueACCrOrigen, setValueACCrOrigen] = useState
    (
      itemCrud.crOrigen
    )
  const [inputValueACCrOrigen, setInputValueACCrOrigen] = useState("");

  //
  // ################################################################################
  // 
  useEffect(() => {
    loadBlCrMarcas();
    loadBlCrMateriales();
    loadBlCrTipos();
    loadBlCrColores();
    loadCrOrigenes();

    if (actionCrud === "new") {
      setItemCrudLocal(initialState);
    } else {
      setItemCrudLocal(itemCrud);
    }
  }, []);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACBlCrMarca) {
      if (itemCrud && itemCrud.blCrMarca) {
        if (itemCrud.blCrMarca.id !== valueACBlCrMarca.id || (itemCrud.blCrSubMarca !== valueACBlCrSubMarca)) {
          setValueACBlCrSubMarca(null);
        }
        loadBlCrSubMarcas(valueACBlCrMarca.id);
      } else {
        setValueACBlCrSubMarca(null);
      }
      loadBlCrSubMarcas(valueACBlCrMarca.id);
    }
  }, [valueACBlCrMarca])
  //
  // ################################################################################
  // 
  useEffect(() => {

    let _blCrTipo = valueACBlCrTipo ? valueACBlCrTipo.label + " | " : "";
    let _crOrigen = valueACCrOrigen ? valueACCrOrigen.label + " | " : "";
    let _blCrMaterial = valueACBlCrMaterial ? valueACBlCrMaterial.label + " | " : "";
    let _blCrSubMarca = valueACBlCrSubMarca ? valueACBlCrSubMarca.label + " | " : "";
    let _blCrColor = valueACBlCrColor ? valueACBlCrColor.label : "";
    let _descripcion = _blCrTipo + _crOrigen + _blCrMaterial + _blCrSubMarca + _blCrColor;

    setItemCrudLocal((prev) => ({
      ...prev,
      descripcion: _descripcion,
    }));
  }, [valueACBlCrTipo, valueACCrOrigen, valueACBlCrMaterial, valueACBlCrSubMarca, valueACBlCrColor]);
  //
  // ################################################################################
  //
  const loadBlCrMarcas = async () => {
    const response = await getCacheData("bl_cr_marca");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMarcas(_var);
    } else {
      setBlCrMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrSubMarcas = async (idBlCrMarca) => {
    const response = await getBlCrSubMarcas({ idBlCrMarca: idBlCrMarca });
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrSubMarcas(_var);
    } else {
      setBlCrSubMarcas([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrMateriales = async () => {
    const response = await getCacheData("bl_cr_material");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrMateriales(_var);
    } else {
      setBlCrMateriales([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrTipos = async () => {
    const response = await getCacheData("bl_cr_tipo");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrTipos(_var);
    } else {
      setBlCrTipos([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadBlCrColores = async () => {
    setIsDoingSomething(true);
    const response = await getCacheData("bl_cr_color");
    if (response.ok) {
      setIsDoingSomething(false);
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setBlCrColores(_var);
    } else {
      setIsDoingSomething(false);
      setBlCrColores([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadCrOrigenes = async () => {
    const response = await getCacheData("cr_origen");
    if (response.ok) {
      let _response = response.data.data;
      let _var = [];
      _response.forEach((item) => {
        _var.push({
          id: item.id,
          label: item.descripcion,
        });
      });
      setCrOrigenes(_var);
    } else {
      setCrOrigenes([]);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };  //
  // ################################################################################ 
  //
  const handleCloseDialog = () => {
    onClose();
  };
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setItemCrudLocal({
      ...itemCrudLocal,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleSave = () => {
    if (actionCrud === "new" || actionCrud === "update") {

      if (!valueACBlCrMarca) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Marca del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrSubMarca) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar la Submarca del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACCrOrigen) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Origen del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrMaterial) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Material del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrTipo) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Tipo del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!valueACBlCrColor) {
        setMessage({
          severity: "error",
          messageText: "Debes seleccionar el Color del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcion) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción del Producto",
        });
        setShowMessage(true);
        return;
      }

      if (!itemCrudLocal.descripcionCorta) {
        setMessage({
          severity: "error",
          messageText: "Debes ingresar la Descripción abreviada del Producto",
        });
        setShowMessage(true);
        return;
      }
    }
    save();
  };
  //
  // ########################################################################## 
  //
  const save = async () => {
    let _itemCrud = {
      id_bl_cr_tipo: valueACBlCrTipo.id,
      id_bl_cr_material: valueACBlCrMaterial.id,
      id_cr_origen: valueACCrOrigen.id,
      id_bl_cr_marca: valueACBlCrMarca.id,
      id_bl_cr_submarca: valueACBlCrSubMarca.id,
      id_bl_cr_color: valueACBlCrColor.id,
      descripcion: itemCrudLocal.descripcion,
      descripcion_corta: itemCrudLocal.descripcionCorta,
      observaciones: itemCrudLocal.observaciones,
      disponible_obra_social: itemCrudLocal.disponibleOs,
    };
    if (actionCrud !== "new") {
      _itemCrud.id = itemCrud.id;
    }

    setIsDoingSomething(true);
    const response = await saveCristalProducto(actionCrud, _itemCrud);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    } else {
      setIsDoingSomething(false);
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Dialog
        open={true}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            return;
          }
          handleCloseDialog();
        }}
        disableEscapeKeyDown={true}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {actionCrud === "new"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Editando"
              : actionCrud === "enable"
                ? "Habilitando"
                : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={handleCloseDialog}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-marca-producto"
                size="small"
                value={
                  valueACBlCrMarca && valueACBlCrMarca.id
                    ? valueACBlCrMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrMarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrMarca(newInputValue);
                }}
                options={blCrMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Marca del Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-submarca-producto"
                size="small"
                value={
                  valueACBlCrSubMarca && valueACBlCrSubMarca.id
                    ? valueACBlCrSubMarca
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrSubMarca(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrSubmarca: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrSubMarca}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrSubMarca(newInputValue);
                }}
                options={blCrSubMarcas}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="SubMarca del Producto" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-origen"
                size="small"
                value={
                  valueACCrOrigen && valueACCrOrigen.id
                    ? valueACCrOrigen
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACCrOrigen(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idCrOrigen: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACCrOrigen}
                onInputChange={(event, newInputValue) => {
                  setInputValueACCrOrigen(newInputValue);
                }}
                options={crOrigenes}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Origen" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-material"
                size="small"
                value={
                  valueACBlCrMaterial && valueACBlCrMaterial.id
                    ? valueACBlCrMaterial
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrMaterial(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrMaterial: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrMaterial}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrMaterial(newInputValue);
                }}
                options={blCrMateriales}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Material" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-tipo"
                size="small"
                value={
                  valueACBlCrTipo && valueACBlCrTipo.id
                    ? valueACBlCrTipo
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrTipo(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrTipo: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrTipo}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrTipo(newInputValue);
                }}
                options={blCrTipos}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Tipo" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={6}>
              <Autocomplete
                sx={{ width: "100%" }}
                id="id-color"
                size="small"
                value={
                  valueACBlCrColor && valueACBlCrColor.id
                    ? valueACBlCrColor
                    : null
                }
                onChange={(event, newValue) => {
                  setValueACBlCrColor(newValue);
                  setItemCrudLocal({
                    ...itemCrudLocal,
                    idBlCrColor: newValue ? newValue.id : "",
                  });
                }}
                inputValue={inputValueACBlCrColor}
                onInputChange={(event, newInputValue) => {
                  setInputValueACBlCrColor(newInputValue);
                }}
                options={blCrColores}
                getOptionLabel={(option) => option.label || ""}
                renderInput={(params) => <TextField {...params} label="Color" />}
                isOptionEqualToValue={(option, value) => {
                  if (!value || !value.id) return false;
                  return option.id === value.id;
                }}
                disableClearable={true}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={4}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={itemCrudLocal.disponibleOs ?? false}
                    onChange={handleChange}
                    name="disponibleOs"
                    color="primary"
                    disabled={
                      actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                    }
                  />
                }
                label="Disponible para Obra Social"
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion"
                label="Descripción"
                variant="outlined"
                size="small"
                name="descripcion"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                // disabled={
                //   actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                // }
                disabled={true}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                sx={{ width: "100%" }}
                inputProps={{
                  autoComplete: "off",
                }}
                id="descripcion_corta"
                label="Descripción Abreviada"
                variant="outlined"
                size="small"
                name="descripcionCorta"
                value={itemCrudLocal.descripcionCorta}
                onChange={handleChange}
                onFocus={() => {
                  if (itemCrudLocal.descripcionCorta === "") {
                    setItemCrudLocal({
                      ...itemCrudLocal,
                      descripcionCorta: itemCrudLocal.descripcion,
                    });
                  }
                }}
                disabled={
                  actionCrud === "disable" || actionCrud === "enable" || actionCrud === "view"
                }
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                fullWidth
                inputProps={{
                  autoComplete: "off"
                }}
                id="observaciones"
                label="Observaciones"
                variant="outlined"
                name="observaciones"
                value={itemCrudLocal.observaciones}
                onChange={handleChange}
                disabled={actionCrud === "disable" || actionCrud === "enable"}
                multiline
                rows={3}
                sx={{
                  "& .MuiInputBase-root": {
                    minHeight: '80px'
                  }
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Box
                sx={{ display: "flex", justifyContent: "flex-end", pt: 1 }}
              >
                <Button
                  sx={{ mr: 1 }}
                  variant="contained"
                  onClick={handleSave}
                  color={actionCrud === "disable" ? "error" : "primary"}
                  startIcon={
                    actionCrud === "disable" ? (
                      <RemoveCircleOutlineIcon />
                    ) : actionCrud === "enable" ? (
                      <AddCircleOutlineIcon />
                    ) : (
                      <SaveIcon />
                    )
                  }
                >
                  {actionCrud === "disable"
                    ? "Deshabilitar"
                    : actionCrud === "enable"
                      ? "Habilitar"
                      : "Guardar"}
                </Button>

                <Button
                  variant="outlined"
                  onClick={handleCloseDialog}
                >
                  Cancelar
                </Button>
              </Box>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog >

      < WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default CristalProductoDialog;
